/* eslint-disable react/require-default-props */
import * as React from "react";
import formGroupStyles from "../css/formgroup.module.css";

interface PfTextPErcentageProps {
  id: string;
  externalBindedValue: number | "";
  min?: string;
  max?: string;
  onPercentChange: (e: React.FormEvent<HTMLInputElement>) => void;
  width?: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const PfTextPErcentage = ({
  id,
  externalBindedValue,
  min = "1",
  max = "99",
  onPercentChange,
  width = "15%",
  onBlur,
  ...rest
}: PfTextPErcentageProps) => {
  return (
    <input
      {...rest}
      className={formGroupStyles["input-group"]}
      id={id}
      style={{ width }}
      type="number"
      min={min}
      max={max}
      step="1"
      value={externalBindedValue}
      onKeyDown={e => {
        if (e.key === ".") {
          e.preventDefault();
        }
      }}
      onBlur={onBlur}
      onChange={e => {
        const target = e.target as HTMLInputElement;
        const { value } = target;

        if (!target.validity.valid) {
          target.value = value.substring(0, value.length - 1);
          return false;
        }
        const idx = value.indexOf(".");
        if (idx >= 0) {
          target.value = value.substring(0, value.length - 1);
          return false;
        }
        onPercentChange(e);
        return true;
      }}
    />
  );
};
